import ParentPageReferralCard from './components/ParentPageReferralCard';

const ParentPageAside = () => {
  return (
    <aside className="flex flex-col gap-8 max-w-[clamp(290px,28.7vw,413px)] min-w-[clamp(290px,28.7vw,413px)]">
      <ParentPageReferralCard />
    </aside>
  );
};

export default ParentPageAside;
